var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h500v500H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#005692",
    strokeWidth: 14,
    d: "M407.744 313.812c.004-.38-.273-.688-.618-.688 0 0 0 0 0 0l-36.876.064s0 0 0 0c-20.006.035-37.37.035-38.75 0 0 0 0 0 0 0-1.38-.035-9.446 11.138-18 24.936 0 0 0 0 0 0-8.554 13.797-33.424 25-55.5 25h-14c-22.076 0-47.954-11.203-57.75-25 0 0 0 0 0 0-9.796-13.798-18.982-25-20.5-25 0 0 0 0 0 0h-40.094s0 0 0 0H87.968s0 0 0 0c-.19 0-.344.253-.344.564 0 0 0 0 0 0l-.058 40.564-.008 6c-.032 22.076 17.866 40 39.942 40h240.124c22.076 0 40.023-17.924 40.052-40l.008-5.752c.029-22.076.056-40.308.06-40.688 0 0 0 0 0 0zM272.132 189H322.5s0 0 0 0c3.587 0 8.148 2.64 10.178 5.89 0 0 0 0 0 0 2.03 3.25 13.292 21.018 25.133 39.65l49.941 78.584m-320.128 0l50.272-77.605a56712.242 56712.242 0 0025.926-40.045s0 0 0 0C166.128 191.901 171.137 189 175 189c0 0 0 0 0 0h48.808",
    fill: "none",
    display: "block"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#00BAEF",
    strokeWidth: 13.2391,
    d: "M303.998 141.674l-55.672-55.677-56.024 56.025M248.3 86.519v215.003",
    fill: "none",
    display: "block"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.4a2516f9.svg";
export { ForwardRef as ReactComponent };